export const ATHLETE_PHYSIQUE_PAGE = 2;
export const ATHLETE_ACADEMIC_PAGE = 3;
export const ATHLETE_COMPLETE_ONBOARDING = 4;
export const ATHLETE_PROFILE_PAGE = 0;
